/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CountsByKey } from '../model';
// @ts-ignore
import { TotalCount } from '../model';
/**
 * BooksApi - axios parameter creator
 * @export
 */
export const BooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 書籍・雑誌の全数カウント。雑誌は書籍に含まれる。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/books/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 書籍・雑誌の出版社別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountsByPublisher: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/books/publishers/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BooksApi - functional programming interface
 * @export
 */
export const BooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 書籍・雑誌の全数カウント。雑誌は書籍に含まれる。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 書籍・雑誌の出版社別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountsByPublisher(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountsByKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountsByPublisher(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BooksApi - factory interface
 * @export
 */
export const BooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BooksApiFp(configuration)
    return {
        /**
         * 書籍・雑誌の全数カウント。雑誌は書籍に含まれる。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCount(options?: any): AxiosPromise<TotalCount> {
            return localVarFp.getCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 書籍・雑誌の出版社別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountsByPublisher(options?: any): AxiosPromise<CountsByKey> {
            return localVarFp.getCountsByPublisher(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BooksApi - interface
 * @export
 * @interface BooksApi
 */
export interface BooksApiInterface {
    /**
     * 書籍・雑誌の全数カウント。雑誌は書籍に含まれる。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApiInterface
     */
    getCount(options?: AxiosRequestConfig): AxiosPromise<TotalCount>;

    /**
     * 書籍・雑誌の出版社別カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApiInterface
     */
    getCountsByPublisher(options?: AxiosRequestConfig): AxiosPromise<CountsByKey>;

}

/**
 * BooksApi - object-oriented interface
 * @export
 * @class BooksApi
 * @extends {BaseAPI}
 */
export class BooksApi extends BaseAPI implements BooksApiInterface {
    /**
     * 書籍・雑誌の全数カウント。雑誌は書籍に含まれる。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApi
     */
    public getCount(options?: AxiosRequestConfig) {
        return BooksApiFp(this.configuration).getCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 書籍・雑誌の出版社別カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BooksApi
     */
    public getCountsByPublisher(options?: AxiosRequestConfig) {
        return BooksApiFp(this.configuration).getCountsByPublisher(options).then((request) => request(this.axios, this.basePath));
    }
}
